import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { acoplamentosService } from '../../services';

export const AcoplamentosFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Acoplamento"
      service={acoplamentosService}
      redirectPath="/admin/logistica/acoplamentos"
      fields={[
        { name: 'caminhao', label: 'Caminhão', type: 'select', required: true },
        { name: 'reboque', label: 'Reboque', type: 'select', required: true },
        { name: 'data_inicio', label: 'Data de Início', type: 'date' },
        { name: 'data_fim', label: 'Data de Fim', type: 'date' },
        { name: 'ativo', label: 'Ativo', type: 'select', options: [
          { value: 'true', label: 'Sim' },
          { value: 'false', label: 'Não' },
        ]},
        { name: 'observacoes', label: 'Observações', type: 'textarea' },
      ]}
    />
  );
};
